define('views/shop/instore/merchant',[
    'views/_base/baseview',
    'text!views/shop/instore/merchant.html',
], function (BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'merchant',
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click': 'showMerchantView',
            'mouseenter' : 'onMerchantHover',
            'mouseleave' : 'onMerchantUnHover'
        },
        initialize: function(options){
            options = options || {};

            this.merchant = options.data;
            this.data = options.data.toJSON();

            if(options.map){
                this.map_container = options.map;
            }

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            return this;
        },

        onMerchantHover: function(){

            if(this.map_container){
                this.map_container.showInfoWindow(this.merchant);
            }
            
        },

        showMerchantView: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }
            
            var url = genLinkURL(enums.linkType.merchantInfo, this.data.MerchantGroupGUID, this.data.MerchantGUID);
            pf.navigate(url);
        },

        close: function(){}
    });
});

